<template>
  <div class="home">
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {
    
  },
  created() {
    if(this.$store.state.auth?.oidc?.user) {
      this.$router.push({ path: `/imar` });
    }
  }
};
</script>
